import React, { createContext, useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { warehouseApi } from 'api';

const WarehouseContext = createContext(null);
const STORAGE_KEY = 'selectedWarehouse';

const WarehouseProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [warehouses, setWarehouses] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);

  useEffect(() => {
    const fetchWarehouses = async () => {
      try {
        setLoading(true);
        const response = await warehouseApi.getList();
        const warehouseList = response.results;

        setWarehouses(warehouseList);

        // 저장된 warehouse 있는지 확인
        const savedWarehouse = localStorage.getItem(STORAGE_KEY);

        if (savedWarehouse) {
          const parsedWarehouse = JSON.parse(savedWarehouse);

          // 현재 목록에 저장된 warehouse 있는지 확인
          const isWarehouseValid = warehouseList.some(
            w => w.id === parsedWarehouse.id,
          );

          if (isWarehouseValid) {
            handleWarehouseChange(parsedWarehouse);
          } else {
            // 저장된 warehouse 유효하지 않으면 첫 번째 warehouse 선택
            handleWarehouseChange(warehouseList[0]);
          }
        } else if (warehouseList.length > 0) {
          // 저장된 값이 없으면 첫 번째 warehouse 선택
          handleWarehouseChange(warehouseList[0]);
        }
      } catch (error) {
        toast.error('Failed to fetch warehouses');
      } finally {
        setLoading(false);
      }
    };

    if (!selectedWarehouse) {
      fetchWarehouses();
    }
  }, []);

  const handleWarehouseChange = warehouse => {
    setSelectedWarehouse(warehouse);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(warehouse));
  };

  return (
    <WarehouseContext.Provider
      value={{
        warehouses,
        selectedWarehouse,
        setSelectedWarehouse: handleWarehouseChange,
        loading,
      }}
    >
      {children}
    </WarehouseContext.Provider>
  );
};

export const useWarehouseContext = () => useContext(WarehouseContext);

export default WarehouseProvider;
